/*
  Himmelpfort Kaffee · Warenkorb-Mengenhinweis
  Datei: assets/hk-cart-consumption-hint.js

  Zeigt einen dezenten Hinweis, wenn genau eine 250-g-Packung
  Kaffee oder Espresso im Warenkorb liegt.

  Funktioniert:
  - im Cart Drawer
  - auf der normalen Warenkorbseite /cart

  Bestehende Warenkorb-, Mengen-, Versand- und Checkout-Logik wird nicht verändert.
*/

(function () {
  'use strict';

  var DRAWER_HINT_ID = 'HkCartConsumptionHintDrawer';
  var PAGE_HINT_ID = 'HkCartConsumptionHintPage';
  var STYLE_ID = 'HkCartConsumptionHintStyles';
  var updateTimer = null;
  var requestNumber = 0;

  function normalize(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.hk-cart-consumption-hint{',
      '  padding:13px 14px;',
      '  background:#f8f8f8;',
      '  border:1px solid rgba(82,98,32,.22);',
      '  border-radius:14px;',
      '  color:#2f2a24;',
      '  text-align:center;',
      '  font-family:var(--font-body-family),var(--font-body),-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;',
      '}',
      '.hk-cart-consumption-hint--drawer{margin:0 20px 14px;}',
      '.hk-cart-consumption-hint--page{margin:16px 0 12px;}',
      '.hk-cart-consumption-hint__title{',
      '  margin:0 0 4px;',
      '  color:#354013;',
      '  font-size:14px;',
      '  font-weight:800;',
      '  line-height:1.3;',
      '}',
      '.hk-cart-consumption-hint__text{',
      '  margin:0 0 9px;',
      '  color:#665f57;',
      '  font-size:12.5px;',
      '  line-height:1.45;',
      '}',
      '.hk-cart-consumption-hint__button{',
      '  appearance:none;',
      '  -webkit-appearance:none;',
      '  display:inline-flex;',
      '  min-height:36px;',
      '  align-items:center;',
      '  justify-content:center;',
      '  padding:8px 13px;',
      '  color:#9b5310;',
      '  background:#fff8ef;',
      '  border:1px solid rgba(230,136,25,.55);',
      '  border-radius:999px;',
      '  box-shadow:none;',
      '  font:inherit;',
      '  font-size:13px;',
      '  font-weight:800;',
      '  line-height:1.2;',
      '  cursor:pointer;',
      '  margin:0 auto;',
      '}',
      '.hk-cart-consumption-hint__button:hover{',
      '  color:#7c430d;',
      '  background:#fff2df;',
      '  border-color:#e68819;',
      '}',
      '.hk-cart-consumption-hint__button:focus:not(:focus-visible){outline:none;}',
      '.hk-cart-consumption-hint__button:focus-visible{',
      '  outline:2px solid #526220;',
      '  outline-offset:3px;',
      '}',
      '@media(max-width:749px){',
      '  .hk-cart-consumption-hint--drawer{margin:0 16px 12px;}',
      '  .hk-cart-consumption-hint--page{margin:14px 0 10px;}',
      '  .hk-cart-consumption-hint__button{width:100%;}',
      '}'
    ].join('');

    document.head.appendChild(style);
  }

  function fetchCart() {
    return fetch(`${theme.routes.cart}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Warenkorb konnte nicht geladen werden.');
      return response.json();
    });
  }

  function itemText(item) {
    var optionText = Array.isArray(item.options_with_values)
      ? item.options_with_values.map(function (option) {
          return option && option.value ? option.value : '';
        }).join(' ')
      : '';

    return normalize([
      item.product_title,
      item.variant_title,
      item.product_type,
      item.handle,
      item.url,
      optionText
    ].join(' '));
  }

  function isCoffeeItem(item) {
    return /kaffee|espresso|caff[eè]\s*crema|bohnen/.test(itemText(item));
  }

  function getItemPackWeightInGrams(item) {
    if (!item) return 0;

    var values = [];

    if (item.variant_title) values.push(item.variant_title);

    if (Array.isArray(item.options_with_values)) {
      item.options_with_values.forEach(function (option) {
        if (option && option.value) values.push(option.value);
      });
    }

    values.push(item.product_title || '');
    values.push(item.url || '');

    var text = normalize(values.join(' '));

    var kgMatch = text.match(/(^|\D)(\d+(?:[.,]\d+)?)\s*kg(\D|$)/);
    if (kgMatch) {
      return Math.round(parseFloat(kgMatch[2].replace(',', '.')) * 1000);
    }

    var gramMatches = text.match(/(^|\D)(\d{2,4})\s*g(\D|$)/g);
    if (gramMatches && gramMatches.length) {
      for (var i = 0; i < gramMatches.length; i++) {
        var numberMatch = gramMatches[i].match(/(\d{2,4})/);
        if (numberMatch) {
          var grams = Number(numberMatch[1]);
          if (grams >= 100 && grams <= 2000) return grams;
        }
      }
    }

    return 0;
  }

  function getCoffeeWeightInGrams(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      if (!isCoffeeItem(item)) return total;

      var packWeight = getItemPackWeightInGrams(item);
      var quantity = Math.max(0, Number(item.quantity) || 0);

      return total + (packWeight * quantity);
    }, 0);
  }

  function shouldShowConsumptionHint(cart) {
    var coffeeWeight = getCoffeeWeightInGrams(cart);

    return coffeeWeight > 0 && coffeeWeight < 1000;
  }

  function getDefaultDrinkForCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return 'filter';

    var coffeeItems = cart.items.filter(isCoffeeItem);
    var combinedText = coffeeItems.map(itemText).join(' ');

    if (/caff[eè]\s*crema/.test(combinedText)) return 'crema';

    var hasEspresso = /espresso/.test(combinedText);
    var hasCoffee = coffeeItems.some(function (item) {
      var text = itemText(item);
      return !/espresso|caff[eè]\s*crema/.test(text);
    });

    if (hasEspresso && !hasCoffee) return 'espresso';
    return 'filter';
  }

  function removeHint(id) {
    var existing = document.getElementById(id);
    if (existing) existing.remove();
  }

  function createHint(id, modifierClass, defaultDrink) {
    var hint = document.createElement('aside');
    hint.id = id;
    hint.className = 'hk-cart-consumption-hint ' + modifierClass;
    hint.setAttribute('aria-label', 'Hilfe zur passenden Kaffeemenge');

    hint.innerHTML =
      '<p class="hk-cart-consumption-hint__title">Unsicher, ob die Menge reicht?</p>' +
      '<p class="hk-cart-consumption-hint__text">Berechne, welche Packungsgröße zu deinem Verbrauch passt.</p>' +
      '<button type="button" class="hk-cart-consumption-hint__button" ' +
      'data-hk-cart-consumption-open ' +
      'data-hk-abo-default-drink="' + defaultDrink + '" ' +
      'aria-haspopup="dialog" aria-controls="HkAboCalculatorModal">' +
      'Kaffeeverbrauch berechnen' +
      '</button>';

    return hint;
  }

  function placeDrawerHint(cart) {
    removeHint(DRAWER_HINT_ID);

    if (!shouldShowConsumptionHint(cart)) return;

    var drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('.yipi-cart-drawer') ||
      document.querySelector('#CartDrawer');

    if (!drawer) return;

    var host =
      drawer.querySelector('.yipi-cart-refinement-slot') ||
      drawer.querySelector('.yipi-cart-drawer__sub-footer') ||
      drawer.querySelector('.cart-drawer__sub-footer') ||
      drawer.querySelector('[data-cart-dynamic-content="cart-footer"]') ||
      drawer.querySelector('.global-drawer__body--content');

    if (!host || !host.parentNode) return;

    var hint = createHint(
      DRAWER_HINT_ID,
      'hk-cart-consumption-hint--drawer',
      getDefaultDrinkForCart(cart)
    );

    if (host.classList.contains('yipi-cart-refinement-slot')) {
      host.insertAdjacentElement('afterend', hint);
    } else {
      host.parentNode.insertBefore(hint, host);
    }
  }

  function findCartPageSummaryHost() {
    var checkoutButton =
      document.querySelector('button[name="checkout"]') ||
      document.querySelector('.cart__checkout-button') ||
      document.querySelector('form[action="/cart"] button[type="submit"]');

    if (!checkoutButton) return null;

    var node = checkoutButton.parentElement;

    for (var i = 0; node && i < 7; i++) {
      var text = normalize(node.textContent);

      if (
        text.indexOf('zwischensumme') !== -1 ||
        text.indexOf('bestellübersicht') !== -1 ||
        node.classList.contains('cart__footer') ||
        node.querySelector('.totals, [class*="totals"]')
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return checkoutButton.parentElement;
  }

  function placeCartPageHint(cart) {
    removeHint(PAGE_HINT_ID);

    if (
      window.location.pathname.replace(/\/+$/, '') !==
      theme.routes.cart.replace(/\/+$/, '')
    ) return;
    if (!shouldShowConsumptionHint(cart)) return;

    var host = findCartPageSummaryHost();
    if (!host) return;

    var hint = createHint(
      PAGE_HINT_ID,
      'hk-cart-consumption-hint--page',
      getDefaultDrinkForCart(cart)
    );

    var checkoutButton =
      host.querySelector('button[name="checkout"]') ||
      host.querySelector('.cart__checkout-button') ||
      host.querySelector('button[type="submit"]');

    if (checkoutButton) {
      checkoutButton.insertAdjacentElement('beforebegin', hint);
    } else {
      host.appendChild(hint);
    }
  }

  function updateHints() {
    var currentRequest = ++requestNumber;

    fetchCart()
      .then(function (cart) {
        if (currentRequest !== requestNumber) return;

        placeDrawerHint(cart);
        placeCartPageHint(cart);
      })
      .catch(function () {
        removeHint(DRAWER_HINT_ID);
        removeHint(PAGE_HINT_ID);
      });
  }

  function scheduleUpdate(delay) {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(
      updateHints,
      typeof delay === 'number' ? delay : 120
    );
  }

  function openCalculator(button) {
    var drawer = button.closest('cart-drawer, .yipi-cart-drawer, #CartDrawer');
    var closeButton = drawer
      ? drawer.querySelector('[data-drawer-close], .global-drawer__close')
      : null;

    var defaultDrink =
      button.getAttribute('data-hk-abo-default-drink') || 'filter';

    if (closeButton) closeButton.click();

    window.setTimeout(function () {
      var proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.hidden = true;
      proxy.setAttribute('data-hk-abo-calculator-open', '');
      proxy.setAttribute('data-hk-abo-default-drink', defaultDrink);
      proxy.setAttribute('aria-controls', 'HkAboCalculatorModal');
      document.body.appendChild(proxy);
      proxy.click();
      proxy.remove();
    }, closeButton ? 220 : 0);
  }

  document.addEventListener('click', function (event) {
    var calculatorButton = event.target.closest('[data-hk-cart-consumption-open]');

    if (calculatorButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openCalculator(calculatorButton);
      return;
    }

    if (
      event.target.closest('[aria-controls="CartDrawer"]') ||
      event.target.closest('.js-drawer-open-right-link') ||
      event.target.closest('[data-cart-quantity-button]') ||
      event.target.closest('quantity-input button') ||
      event.target.closest('[data-cart-remove-item]') ||
      event.target.closest('cart-remove-button') ||
      event.target.closest('.cart-item__remove') ||
      event.target.closest('[href*="/cart/change"]') ||
      event.target.closest('form[action*="/cart/add"] button[type="submit"]')
    ) {
      scheduleUpdate(180);
      window.setTimeout(updateHints, 500);
      window.setTimeout(updateHints, 900);
      window.setTimeout(updateHints, 1400);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches(
        '[data-cart-quantity-input], input[name="updates[]"], input[name^="updates["], .quantity__input'
      )
    ) {
      scheduleUpdate(180);
      window.setTimeout(updateHints, 500);
      window.setTimeout(updateHints, 900);
      window.setTimeout(updateHints, 1400);
    }
  });

  document.addEventListener('cart:updated', function () {
    scheduleUpdate(100);
  });

  document.addEventListener('cart:refresh', function () {
    scheduleUpdate(100);
  });

  document.addEventListener('hk:cart-shipping-updated', function () {
    scheduleUpdate(60);
  });

  document.addEventListener('shopify:section:load', function () {
    scheduleUpdate(100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      addStyles();
      scheduleUpdate(0);
      window.setTimeout(updateHints, 700);
    });
  } else {
    addStyles();
    scheduleUpdate(0);
    window.setTimeout(updateHints, 700);
  }
})();
